export default __webpack_public_path__ + "static/6-4932ae50cba58a5ded9599b1365c8c2f.svg";